import { Card } from "antd";
import { GetDashboardDataResponse } from "../../../../features/organization/dashboard/dashboard.type";
import CloseIcon from "../_icons/CloseIcon";
import CloseRequestIcon from "../_icons/CloseRequestIcon";
import CompletedIcon from "../_icons/CompletedIcon";
import FailedIcon from "../_icons/FailedIcon";
import HiredIcon from "../_icons/HiredIcon";
import { default as JobIcon } from "../_icons/JobIcon";
import PendingIcon from "../_icons/PendingIcon";
import ProposalIcon from "../_icons/ProposalIcon";
import RequestPayment from "../_icons/RequestPayment";

type Props = {
  data?: GetDashboardDataResponse;
};

const Summery = ({ data }: Props) => {
  const statsIcons: Record<string, React.ReactNode> = {
    job_post: <JobIcon />,
    hired: <HiredIcon />,
    pending: <PendingIcon />,
    close_request: <CloseRequestIcon />,
    close: <CloseIcon />,
    proposal: <ProposalIcon />,
    payment_pending: <RequestPayment />,
    task_not_submitted: <RequestPayment />,
    // send_to_disbursement: <BagIcon />,
    completed: <CompletedIcon />,
    failed: <FailedIcon />,
  };

  const statsData = [
    {
      key: "job_post",
      title: "Jobs Posted",
      value: data?.overview?.totalJobs,
      description: "Total Job Posted",
    },
    {
      key: "hired",
      title: "Hired",
      value: data?.jobApplications?.hired,
      description: "Number of People Hired",
    },
    {
      key: "pending",
      title: "Pending",
      value: data?.jobApplications?.pendingNotHired,
      description: "Pending Proposals",
    },
    {
      key: "close_request",
      title: "Close Request",
      value: data?.jobApplications?.submittedNotClosed,
      description: "Requests To Close",
    },
    {
      key: "close",
      title: "Close",
      value: data?.jobApplications?.closedJobs,
      description: "Closed Applications",
    },
    {
      key: "task_not_submitted",
      title: "Pending",
      value: data?.jobApplications?.hiredNotSubmitted,
      description: "Task Not Submitted",
    },
    {
      key: "proposal",
      title: "Proposal",
      value: data?.overview?.totalJobApplies,
      description: "Total Proposals",
    },
    {
      key: "payment_pending",
      title: "Pending",
      value: data?.payments?.paymentsByStatus?.pending,
      description: "Payments Pending",
    },
    // {
    //   key: "send_to_disbursement",
    //   title: "Send",
    //   value: data?.payments?.paymentsByStatus?.send_to_disbursement,
    //   description: "Send to Disbursement",
    // },
    {
      key: "completed",
      title: "Completed",
      value: data?.payments?.paymentsByStatus?.completed,
      description: "Payments Completed",
    },
    {
      key: "failed",
      title: "Failed",
      value: data?.payments?.paymentsByStatus?.failed,
      description: "Payments Failed",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[18px]">
      {statsData?.map((data) => (
        <Card
          className="rounded-lg shadow-sm bg-white border border-gray-100"
          classNames={{
            body: "flex justify-between before:!hidden after:!hidden",
          }}
          key={data?.key}
        >
          {/* Left Section: Icon + Text */}
          <div className="flex items-center gap-3">
            {/* Icon */}
            <div className="w-[46px] h-[46px] rounded-full bg-purple-100 flex items-center justify-center">
              {statsIcons[data.key]}
            </div>
            {/* Title & Subtext */}
            <div>
              <h2 className="text-header font-semibold text-lg">
                {data.title}
              </h2>
              <p className="text-sub-header text-xs">{data.description}</p>
            </div>
          </div>

          {/* Right Section: Count */}
          <div className="text-[42px] font-semibold text-header">
            {data.value || 0}
          </div>
        </Card>
      ))}
    </div>
  );
};

export default Summery;
